import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from "../Button/Button";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";

export default function Navbar({
  loginButtonText,
  loginButtonGradient,
  signupButtonText,
  signupButtonGradient,
  signupTextColor,
  signupBorder,
  signupPadding,
  loginUrl,
  signupUrl,
}) {
  const [navData, setNavData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    fetch("https://api.spadserver.com/api/navbar")
      .then((response) => response.json())
      .then((data) => {
        setNavData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching navbar data:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="text-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!navData || navData.length === 0) {
    return <div className="text-center">404</div>;
  }

  const groupedNavData = navData.reduce((acc, item) => {
    if (!acc[item.title]) {
      acc[item.title] = [];
    }
    const uniqueChildren = item.children.reduce((unique, child) => {
      if (!unique.some((c) => c.slug === child.slug)) {
        unique.push(child);
      }
      return unique;
    }, []);
    acc[item.title].push({ ...item, children: uniqueChildren });
    return acc;
  }, {});

  const customSlugs = {
    دامنه: "domain",
    "درباره اسپاد": "aboutus",
    خدمات: "developers",
    "مشتریان ما": "our-customers",
    "ارتباط با ما": "contact",
  };

  const getLinkUrl = (slug) => {
    return [
      "domain",
      "aboutus",
      "our-customers",
      "contact",
      "developers",
    ].includes(slug)
      ? `/${slug}`
      : `/product/${slug}`;
  };

  return (
    <div className="flex flex-col md:flex-row font-main justify-between items-center p-3 text-md mx-4 md:mx-10 bg-custom-gradient mt-2 border-b-2 border-border">
      <a href="/">
        <div className="logo flex items-center">
          <img
            src="/images/spadLogo.png"
            className="w-24 h-18 mr-4"
            alt="Logo"
          />
        </div>
      </a>

      {/* Toggle button for mobile view */}
      <div className="block md:hidden">
        <button
          className="text-white focus:outline-none"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            ></path>
          </svg>
        </button>
      </div>

      {/* Desktop and mobile menu */}
      <div
        className={`${
          isMenuOpen ? "block" : "hidden"
        } md:flex items-center text-white font-semibold w-full md:w-auto md:space-x-4`}
      >
        {Object.entries(groupedNavData).map(([title, items]) => {
          const slug = customSlugs[title] || "";

          return (
            <div key={title} className="relative group cursor-pointer">
              <div className="hostLink mx-4 md:mx-6 cursor-pointer">
                {title}
              </div>

              {items.length > 0 && (
                <div
                  className={`navbarSubMenu z-10 absolute top-full md:top-12 right-0 w-[300px] md:w-[500px] bg-white p-4 hidden group-hover:block shadow-lg ${
                    isMenuOpen ? "block" : "hidden md:block"
                  }`}
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {items.map((item, index) => (
                      <div key={item.id}>
                        <div
                          className={`pb-1 ${
                            index > 1 ? "border-b border-gray-300" : ""
                          }`}
                        >
                          <p className="text-gray-700 text-sm font-medium">
                            {item.name}
                          </p>
                        </div>
                        <ul className="mt-2">
                          {item.children.map((subItem) => (
                            <li key={subItem.id} className="mt-1">
                              <Link
                                to={getLinkUrl(subItem.slug)}
                                className="text-black text-[11px] hover:bg-gray-100 block font-medium px-2 py-1 rounded-md"
                              >
                                {subItem.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Buttons for desktop */}
      <div className="hidden md:flex">
        <div className="flex space-x-4">
          <div className="loginButton ml-2">
            <a href={loginUrl}>
              <Button text={loginButtonText} gradient={loginButtonGradient} />
            </a>
          </div>

          <div className="signupButton">
            <a href={signupUrl}>
              <Button
                text={signupButtonText}
                gradient={signupButtonGradient}
                textColor={signupTextColor}
                border={signupBorder}
                padding={signupPadding}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
